App.OrderHistoryEventComponent = Em.Component.extend
  classNames: 'order-history-event'

  event: null
  changes: null

  changes:( ->
    results = []
    for key, value of @get('event.changes')
      o =
        'name': key
        'value': value
      results.push o
    results
  ).property('event.changes')

  humanizeCreatedAt:( ->
    ret = moment(@get('event.created_at')).tz(@get('timezone')).format('D MMMM, H:mm')
    ret = (@get('event.api_user_name')  + ', ' + ret) if @get('event.api_user_name')
    ret
  ).property('event.created_at')
